import { render, staticRenderFns } from "./CreateUserGroupFromUserACLModal.vue?vue&type=template&id=84bffb5e&"
import script from "./CreateUserGroupFromUserACLModal.vue?vue&type=script&lang=ts&"
export * from "./CreateUserGroupFromUserACLModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports